<template>
  <div :class="device.desktop ? `chpwd pa-6` : `chpwd pa-2`">
    <v-row class="justify-center ma-0">
      <v-col
        :cols="device.desktop ? 5 : 12"
        class="pa-0"
      >
        <div class="chpwd-panel">
          <div class="chpwd-panel-header">
            <v-icon
              small
              color="#60a5fa"
              class="mr-2"
            >mdi-shield-key-outline</v-icon>
            <span class="chpwd-panel-title">GANTI KATA SANDI</span>
          </div>

          <!-- Ilustrasi & info -->
          <div class="chpwd-hero">
            <div class="chpwd-hero-icon">
              <v-icon
                size="34"
                color="#60a5fa"
              >mdi-lock-reset</v-icon>
            </div>
            <div class="chpwd-hero-title">Perbarui kata sandi akun anda</div>
            <div class="chpwd-hero-note">
              Gunakan kata sandi yang kuat dan tidak dipakai di aplikasi lain
            </div>
          </div>

          <div class="chpwd-divider"></div>

          <!-- Form -->
          <div class="chpwd-form">
            <v-text-field
              label="Kata Sandi Baru"
              dark
              color="#60a5fa"
              background-color="#0a1224"
              v-model="record.password"
              :type="showPass ? `text` : `password`"
              outlined
              dense
              persistent-hint
              hint="Minimal 6 karakter, kombinasi huruf dan angka"
              prepend-inner-icon="mdi-lock-outline"
              :append-icon="showPass ? `mdi-eye-off-outline` : `mdi-eye-outline`"
              @click:append="showPass = !showPass"
            ></v-text-field>

            <v-text-field
              label="Ulangi Kata Sandi Baru"
              dark
              color="#60a5fa"
              background-color="#0a1224"
              v-model="record.repassword"
              :type="showRePass ? `text` : `password`"
              outlined
              dense
              persistent-hint
              :hint="repassHint"
              :error="repassError"
              prepend-inner-icon="mdi-lock-check-outline"
              :append-icon="showRePass ? `mdi-eye-off-outline` : `mdi-eye-outline`"
              @click:append="showRePass = !showRePass"
              v-on:keyup.enter="postChangePassword"
              class="mt-4"
            ></v-text-field>

            <div class="chpwd-form-footer">
              <div class="chpwd-form-note">
                <v-icon
                  x-small
                  color="#94a3b8"
                >mdi-information-outline</v-icon>
                Setelah disimpan, gunakan kata sandi baru saat login
              </div>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                dark
                class="chpwd-btn-save"
                @click="postChangePassword"
              >
                <v-icon
                  left
                  small
                >mdi-content-save-outline</v-icon>
                Simpan
              </v-btn>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Home",
  data: () => ({
    showPass: false,
    showRePass: false,
  }),
  computed: {
    ...mapState(["theme", "http", "device", "record", "snackbar", "info"]),
    repassError() {
      return (
        !!this.record.repassword &&
        this.record.repassword !== this.record.password
      );
    },
    repassHint() {
      return this.repassError
        ? "Kata sandi tidak sama"
        : "Ketik ulang kata sandi baru untuk konfirmasi";
    },
  },
  created() {
    this.setPage({
      crud: true,
      dataUrl: "api/master-tingkat",
      title: "GANTI KATA SANDI",
      subtitle: "Ganti Kata Sandi Pengguna",
      breadcrumbs: [
        {
          text: "Pengguna",
          disabled: false,
          href: "",
        },
        {
          text: "Ganti Kata Sandi",
          disabled: false,
          href: "master-jenis-pengaduan",
        },
      ],
      add: false,
      edit: false,
      actions: {
        refresh: true,
        add: true,
        edit: true,
        delete: true,
      },
    });
  },
  mounted() {},
  methods: {
    ...mapActions(["setPage"]),
    postChangePassword: async function () {
      try {
        if (this.record.password != this.record.repassword) {
          this.snackbar.color = "red";
          this.snackbar.text = "Opps kata sandi tidak sama";
          this.snackbar.state = true;
          return;
        }
        let {
          data: { status, message },
        } = await this.http.post("api/utility/change-pwd", this.record);

        if (!status) {
          this.snackbar.color = "red";
          this.snackbar.text = message;
          this.snackbar.state = true;
          return;
        }

        this.snackbar.color = this.theme.color;
        this.snackbar.text = message;
        this.snackbar.state = true;
        this.record.password = null;
        this.record.repassword = null;
      } catch (error) {
        this.snackbar.color = "red";
        this.snackbar.text = error.data.errors[0].message;
        this.snackbar.state = true;
      }
    },
  },
};
</script>

<style scoped>
.chpwd {
  min-height: 100%;
  background: #0a1224;
}

.chpwd-panel {
  background: #101b36;
  border: 1px solid #1e2c4f;
  border-radius: 12px;
  overflow: hidden;
}

.chpwd-panel-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #1e2c4f;
}

.chpwd-panel-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: #e2e8f0;
}

/* hero */
.chpwd-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 28px 20px 20px 20px;
}

.chpwd-hero-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #0a1224;
  border: 2px solid #1e2c4f;
}

.chpwd-hero-title {
  margin-top: 14px;
  font-size: 15px;
  font-weight: 700;
  color: #e2e8f0;
}

.chpwd-hero-note {
  margin-top: 4px;
  font-size: 12px;
  color: #94a3b8;
}

.chpwd-divider {
  height: 1px;
  background: #1e2c4f;
  margin: 0 16px;
}

/* form */
.chpwd-form {
  padding: 20px;
}

.chpwd-form-footer {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #1e2c4f;
}

.chpwd-form-note {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #94a3b8;
}

.chpwd-btn-save {
  border-radius: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  background: linear-gradient(135deg, #1d4ed8 0%, #0b3a79 100%) !important;
  box-shadow: 0 8px 20px rgba(29, 78, 216, 0.35);
}
</style>
